import axios from "axios";

export function getEventStudentList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "EventStudentMessage/getlistable", config);
}

export function getEventStudentMessageList(data) {
  const config = {
    params: data,
  };
  return axios.get(process.env.VUE_APP_API_URL + "EventStudentMessage/getlist", config);
}

export function postEventStudentMessage(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "EventStudentMessage/add", data, config);
}

export function postEventLecturerMessage(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "EventStudentMessage/addlecturer", data, config);
}
